import { render, staticRenderFns } from "./TransactionsViewTab.vue?vue&type=template&id=5726d9b0&"
import script from "./TransactionsViewTab.vue?vue&type=script&lang=js&"
export * from "./TransactionsViewTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports